// @react/hooks/useFormFormPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { formFormPolicyStore } from '@core/stores';

/**
 * React hook for FormPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFormFormPolicy } from '@react/hooks';
 *
 * const FormPolicyList = observer(() => {
 *   const store = useFormFormPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFormFormPolicy() {
  return formFormPolicyStore;
}
